import type { Data } from '@/api/api.ts'
import type {
  AppendCallsRequestData,
  CampaignDetailDataResponse,
  CampaignTestCallRequestData,
  CampaignTestCallStatusRequestData,
  IvrRequestData,
  Speaker,
} from '@/types/campaignTypes/campaign.types'
import type { GenReportData, ServiceConfigData } from '@/types/campaignTypes/campaignStatistics.types'
import axios from 'axios'
import { useCookies } from 'vue3-cookies'
import { baseUrl } from '@/constants/api.ts'

const urlPrefix = `${baseUrl}phones/`
const urlCampPrefix = `${baseUrl}campaigns/`
const urlSynthCallsPrefix = `${baseUrl}synthcalls/`

export const genStatisticReport = async (campaignId: number, params: any): Promise<Data<GenReportData>> =>
  // eslint-disable-next-line ts/no-unsafe-assignment
  axios.get(`${urlPrefix}stats_xlsx/${campaignId}/`, { params })

export const getServiceConfig = async (campaignId: number): Promise<Data<ServiceConfigData>> =>
  axios.get(`${urlCampPrefix}${campaignId}/service_config/`)

export const addServiceConfig = async (campaignId: number, params: ServiceConfigData): Promise<Data<string>> => {
  const { cookies } = useCookies()

  return axios.post(`${urlCampPrefix}${campaignId}/service_config/`, params, {
    headers: { 'X-CSRFToken': cookies.get('csrftoken') },
  })
}

export const getSynthesizedSpeakers = async (): Promise<Data<{ speakers: Speaker[] }>> =>
  axios.get(`${urlSynthCallsPrefix}speakers/`)

export const appendCalls = async (campaignId: number, data: AppendCallsRequestData): Promise<Data<string>> => {
  const { cookies } = useCookies()

  return axios.post(`${urlPrefix}append_calls/${campaignId}/`, data, {
    headers: { 'X-CSRFToken': cookies.get('csrftoken'), 'Content-Type': 'multipart/form-data' },
  })
}

export const getCampaignDetailData = async (campaignId: number): Promise<{ data: CampaignDetailDataResponse }> =>
  axios.get(`/manager/phones/detail/${campaignId}/info`)

export const getIvrData = async (pinnedId: number): Promise<{ data: IvrRequestData }> =>
  axios.get(`/manager/ivr/json/${pinnedId}/?campaignType=${CAMPAIGN_TYPE}&campaignCountry=${CAMPAIGN_COUNTRY_CODE}`)

export const saveIvrData = async (ivrId: number, data: FormData): Promise<{ data: IvrRequestData }> =>
  axios.post(`/manager/ivr/json/${ivrId}/?campaignType=${CAMPAIGN_TYPE}&campaignCountry=${CAMPAIGN_COUNTRY_CODE}`, data)

export const sendCampaignTestCall = async (
  campaignId: number,
  phone: string,
): Promise<{ data: CampaignTestCallRequestData }> =>
  axios.post(
    `/manager/phones/detail/${campaignId}/testcall/`,
    { phone },
    {
      headers: {
        'X-CSRFToken': CSRF_TOKEN,
        'x-requested-with': 'XMLHttpRequest',
      },
    },
  )

export const getCampaignTestCallStatus = async (
  campaignId: number,
  atsReqKey: string,
): Promise<Data<CampaignTestCallStatusRequestData>> =>
  axios.get(`/manager/cabapi_external/api/v1/phones/testcall/${campaignId}/`, { params: { req_key: atsReqKey } })
